import Vue from "vue";
import App from "./App.vue";
import "./mixin/globalMixins";

import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import VueYoutube from "vue-youtube";
import VueKakaoSdk from "vue-kakao-sdk";
const apiKey = process.env.VUE_APP_KAKAO_API_KEY;
Vue.use(VueKakaoSdk, { apiKey }); // apiKey 를 반드시
Vue.use(VueYoutube);

Vue.use(VueRouter);
Vue.use(VueMeta);

import Vuex from "vuex";
Vue.use(Vuex);

import VueHead from "vue-head";
Vue.use(VueHead);

/* Router & Store */
import store from "./store";
import router from "./router";

// cdn
import LoadScript from "vue-plugin-load-script";
Vue.use(LoadScript);

// Vue.loadScript("https://code.jquery.com/jquery-1.12.4.min.js");
Vue.loadScript("https://cdn.iamport.kr/js/iamport.payment-1.2.0.js");

import vuetify from "./plugins/vuetify";
// window.$ = window.jQuery = require("jquery");

Vue.config.productionTip = false;

export const eventBus = new Vue({
  vuetify
});

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
